import { Panel, TopLevelPanel } from './types.js';

/** Language constants. */
export const Lang = Object.freeze({
  panel: {
    [Panel.Billing]: 'Billing',
    [Panel.Controllers]: 'Controllers',
    [Panel.Profile]: 'Settings',
    [Panel.Organization]: 'Organization',
    [Panel.Studio]: 'Settings',
    [Panel.StudioUsers]: 'Users',
    [Panel.Password]: 'Security',
    [Panel.Notifications]: 'Notifications',
    [Panel.HotKeys]: 'Hot Keys',
    [Panel.Pricing]: 'Plans & Pricing',
    [Panel.Users]: 'Users'
  } satisfies Record<Panel, string>,

  topLevelPanel: {
    [TopLevelPanel.Account]: 'Account',
    [TopLevelPanel.Studio]: 'Studio',
    [TopLevelPanel.Organization]: 'Organization'
  } satisfies Record<TopLevelPanel, string>
});
